import DateFnsUtils from "@date-io/date-fns"
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import moment from "moment"
import { useState } from "react"

export function Datetimepicker({ defaults, onChange, onHide, disablePast, disableFuture, disableToolbar }) {
    const [selectedDate, setSelectedDate] = useState(
        (defaults !== undefined && defaults !== null)
            ? new Date(defaults)
            : new Date(new Date().setHours(23, 59, 0, 0)) // default: aaj ki date, 11:59 PM
    )
    const [openDialog, setOpenDialog] = useState(true)

    const handleDateChange = (newDate) => {
        setSelectedDate(newDate)
        const formattedDate = moment(newDate).format('YYYY-MM-DD HH:mm:ss')
        onChange(formattedDate)
        onHide()
    }

    return (
        // 👇 apna khud ka backdrop — isse background ka field turant cover ho jayega,
        // MUI dialog ke paint hone ka wait nahi karna padega
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.6)",
                zIndex: 1300, // MUI dialog se bhi upar/equal rahe
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                    variant="dialog"
                    value={selectedDate}
                    onChange={handleDateChange}
                    disablePast={disablePast}
                    disableFuture={disableFuture}
                    disableToolbar={disableToolbar}
                    open={openDialog}
                    // backdrop apna use ho raha hai, isliye MUI ke transparent backdrop se click-through na ho
                    DialogProps={{
                        BackdropProps: { style: { backgroundColor: "transparent" } }
                    }}
                    onClose={() => {
                        setOpenDialog(false)
                        onHide()
                    }}
                    animateYearScrolling={true}
                    TransitionProps={{ appear: false }} // fade-in flash kam karega
                />
            </MuiPickersUtilsProvider>
        </div>
    )
}
